import { KatLitFilteredElement, register } from '../../shared/base';
import { KatBlueprintEntityDetail } from '.';

/**
 * @component {kat-blueprint-entity-detail-action} KatBlueprintEntityDetailAction Component used to place and filter components within the action section.
 * @slot default Blueprint content for action section.
 */
@register(KatBlueprintEntityDetail.slotMapping.action.name)
export class KatBlueprintEntityDetailAction extends KatLitFilteredElement {
  constructor() {
    super(
      KatBlueprintEntityDetail.slotMapping.action.name,
      KatBlueprintEntityDetail.slotMapping.action.allowed
    );
  }
}
